module.exports = __webpack_public_path__ + "img/avatar2.c34c491b.png";